import {
  PrimaryButton,
  ReactSelect,
  ReactSelectOption,
} from "@graffer-inc/console-design-kit";
import React from "react";
import { MultiValue, SingleValue } from "react-select";
import {
  OrganizationSessionSetting,
  OrganizationSessionSettingEntity,
  OrganizationSessionSettingValdiator,
} from "../../../../application/domain/organization/org-session-setting";
import { toast } from "react-toastify";

type OrgSessionSettingFormProps = {
  orgID: string;
  availableIdleSessionTimeouts: OrganizationSessionSettingEntity[];
  currentIdleSessionTimeout: OrganizationSessionSettingEntity | null;
  updateOrgIdleSessionTimeoutSetting: (
    orgID: string,
    idleSessionTimeout: OrganizationSessionSetting,
  ) => void;
};

export const OrgSessionSettingForm: React.FC<OrgSessionSettingFormProps> = ({
  orgID,
  availableIdleSessionTimeouts,
  currentIdleSessionTimeout,
  updateOrgIdleSessionTimeoutSetting,
}) => {
  const [selectedIdleSessionTimeout, setSelectedIdleSessionTimeout] =
    React.useState(currentIdleSessionTimeout?.idleSessionTimeoutSecond);

  const validator = React.useMemo(() => {
    if (!selectedIdleSessionTimeout) {
      return new OrganizationSessionSettingValdiator(null);
    }

    const entity = new OrganizationSessionSettingEntity({
      idleSessionTimeoutSecond: selectedIdleSessionTimeout,
    });

    return new OrganizationSessionSettingValdiator(entity);
  }, [selectedIdleSessionTimeout]);

  const options = availableIdleSessionTimeouts.map((v) => ({
    value: v.idleSessionTimeoutSecondValue,
    label: v.idleSessionTimeoutToJapaneseHours,
  }));

  const defaultValue = {
    value: currentIdleSessionTimeout?.idleSessionTimeoutSecondValue || "",
    label: currentIdleSessionTimeout?.idleSessionTimeoutToJapaneseHours || "",
  };

  const handleIdleSessionTimeoutSelect = (
    v:
      | SingleValue<ReactSelectOption<string>>
      | MultiValue<ReactSelectOption<string>>,
  ) => {
    const selected = v as ReactSelectOption<string>;
    setSelectedIdleSessionTimeout(parseInt(selected.value));
  };

  const submitIdleSessionTimeout = () => {
    if (!selectedIdleSessionTimeout) {
      toast.error("セッション有効期間を選択してください。");
      return;
    }

    const orgSessionSetting = new OrganizationSessionSettingEntity({
      idleSessionTimeoutSecond: selectedIdleSessionTimeout,
    });

    updateOrgIdleSessionTimeoutSetting(orgID, orgSessionSetting);
  };

  return (
    <>
      <div className="field">
        <ReactSelect
          key={currentIdleSessionTimeout?.idleSessionTimeoutToJapaneseHours}
          description="操作がない場合に自動ログアウトするまでの時間を 1~12 時間の間で設定できます。"
          label="セッション有効期間"
          onChange={handleIdleSessionTimeoutSelect}
          defaultValue={defaultValue}
          options={options}
          required
          isClearable={true}
          errorMessages={validator.validIdleSessionTimeoutSecond}
        />
      </div>
      <div className="field has-text-right">
        <PrimaryButton
          text="保存"
          onClick={submitIdleSessionTimeout}
          disabled={!validator.isValid()}
        />
      </div>
    </>
  );
};
